import React from "react"
import { Spinner } from "react-bootstrap"
import platformApp from "../Shared/Controller/platformApp"
import { EditImg, DeleteImg } from "../common/ImageConstants";
import { Link } from "react-router-dom";
import * as Constants from "../partials/CommonConstant";
import ConfirmModal from "../common/ConfirmModal";
import NotFound from "../common/NotFound";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

class Platforms extends platformApp {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      platformList: [],
      showModal: false,
      platformId: "",
      page: 1,
      perPage: 10,
      totalRows: 0,
      sortBy: "name",
      sortOrder: "asc",      
      searchText: "",
    }
  }
  componentDidMount = () => {
    this.getPlatforms();
  }

  handlePageChange = (page) => {
    this.setState({ page }, this.getPlatforms);
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ perPage: newPerPage, page }, this.getPlatforms);
  };

  // handleSort = (column, sortDirection) => {
  //   this.setState(
  //     {
  //       sortBy: column.selector,
  //       sortOrder: sortDirection,
  //     },
  //     this.getPlatforms
  //   );
  // };

  // handleSort = (column, sortDirection) => {
  //   const sortBy = column.sortField || column.selector;
  //   this.setState(
  //       {
  //         sortBy: typeof sortBy === 'function' ? '' : sortBy,
  //         sortOrder: sortDirection,
  //       }, () => {
  //       this.getPlatforms(); // Trigger API
  //   });
  // };

  handleSort = (column, sortDirection) => {
    const newSortBy = column.sortField || column.selector;
    
    this.setState((prevState) => ({
      sortBy: newSortBy,
      sortOrder: prevState.sortBy === newSortBy && prevState.sortOrder === "asc" ? "desc" : "asc",
      page: 1, // reset to first page
    }), this.getPlatforms);
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearchSubmit = () => {
    this.setState({ page: 1 }, this.getPlatforms);
  };

  clearSearch = () => {
    this.setState({ searchText: "", page: 1 }, this.getPlatforms);
  };

  getColumnData = (data) => {
    let columnData = "";
    if (data.type === "action") {
      return (
        <div className="edit-icon text-center">
          <Link to={`${Constants.editPlatform}`.replace(':platformId', `${data.item.id}`)} className="ms-2">
            <img src={EditImg} alt="Edit" title="Edit" />
          </Link>
          <Link to="/" className="ms-2" onClick={(e) => this.onClickDelete(e, data.item.id)}>
            <img src={DeleteImg} alt="Delete" title="Delete" />
          </Link>
        </div>
      );
    }
    return columnData;
  }

  render() {

    const {
      platformList,
      loading,
      page,
      perPage,
      totalRows,
      searchText,
    } = this.state;

    // Create table headers
    const data = this.state.platformList;
    const columns = [
      {
        name: "Platform Name",
        selector: row => row.name,
        sortField: "name",
        sortable: true
      },
      {
        name: "Action",
        center: true,
        cell: d => { return this.getColumnData({ type: "action", item: d }) }
      }
    ];

    const tableData = {
      columns,
      data
    };

    return (
      <>
        <div className="dashboard-card-wrapper">
          <ConfirmModal show={this.state.showModal}
            onCloseModal={() => this.onCloseModal()}
            module="platform"
            confirmClick={() => this.handleDelete()} />
          <div className="row align-items-center">
            <div className="col-12 text-end">
              <Link to={Constants.addPlatform} className="btn btn-blue btn-nex me-2">Add Platform</Link>
              <Link to={Constants.deletedPlatforms} className="btn btn-blue btn-nex">Deleted Platform</Link>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12 mt-3">
            <div className="card-main p-0">
              <div className="dark-table-wrapper table-scroll">
                
                {/* Custom Search Input */}
                <div className="data-table-extensions d-flex align-items-center">

                  <div className="data-table-extensions-filter position-relative">

                      <label htmlFor="filterDataTable" className="icon"></label>                        
                      <input
                        type="text"
                        name= "filterDataTable"
                        className="filter-text w-100"
                        placeholder="Search"
                        value={searchText}
                        onChange={(e) => this.setState({ searchText: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({ page: 1 }, this.getPlatforms);
                          }
                        }}                       
                      />
                      
                      {searchText && (
                        <span
                          className="clear-icon"
                          onClick={() => {
                            this.setState({ searchText: "", page: 1 }, this.getPlatforms);
                          }}
                          style={{
                            position: "absolute",
                            right: "13px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "23px",
                            color: "#545454"
                          }}
                          title="Clear search"
                        >
                        ×
                        </span>
                      )}

                  </div>
                    
                  <button
                    className="ms-2"
                    title="Click to Search"
                    disabled={searchText.trim() === ""}
                    style={{
                      backgroundColor: searchText.trim() === "" ? "#f4a75f" : "#ee7608", // lighter when disabled
                      color: "white",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "50px",
                      cursor: searchText.trim() === "" ? "default" : "pointer"
                    }}
                    onClick={() => {
                      this.setState({ page: 1 }, this.getPlatforms);
                    }}
                  >
                    Search
                  </button>

                </div>

                {this.state.platformList && this.state.platformList.length !== 0 && this.state.loading === false &&                  
                  <DataTable
                    columns={columns}
                    data={platformList}
                    progressPending={loading}
                    defaultSortField="name"
                    defaultSortAsc={true}
                    pagination
                    highlightOnHover
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    paginationDefaultPage={page}
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                    onChangePage={this.handlePageChange}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    sortServer={true}
                    onSort={this.handleSort}                      
                    pointerOnHover
                    permanentDelete={0}
                    callbackDeleteTemplate={this.callbackDeleteTemplate}
                  />
                }
                {this.state.loading === true &&
                  <table className="mb-0 table">
                    <tbody>
                      <tr>
                        <td colSpan={10} className="text-center">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }

                {/* Not found */}
                {this.state.loading === false && this.state.platformList && this.state.platformList.length === 0 &&
                  <NotFound message="No Data Found" type="content" />
                }

              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
export default Platforms